import { render, staticRenderFns } from "./SpaceCloset.vue?vue&type=template&id=6dc3a8d3&"
import script from "./SpaceCloset.vue?vue&type=script&lang=js&"
export * from "./SpaceCloset.vue?vue&type=script&lang=js&"
import style0 from "./SpaceCloset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports